var exports = {
  "K": "RecipientRemoveMessage.module__icon___VFZqX1",
};

module.exports = exports;
